import { Row, Col, Form, FormCheck } from "react-bootstrap";

const PlaylistsAddBreak = (
  programDetails,
  setProgramDetails,
  setFormEdited,
  fieldPath,
  isLocked
) => {
  const addBreakPath = programDetails.preRoll[fieldPath].addBreak;
  const mediaRuntimePath = programDetails.preRoll[fieldPath].mediaRuntime;

  // preRoll.file.addBreak.addBreak
  // preRoll.live.addBreak.addBreak
  return (
    <>
      <Row className="align-items-center pt-2 ">
        <Col xs={2}>Break:</Col>
        <Col>
          <Form.Select
            value={addBreakPath.addBreak || ""}
            // xs="2"
            size="sm"
            id="breakInput"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                preRoll: {
                  ...programDetails.preRoll,
                  [fieldPath]: {
                    ...programDetails.preRoll[fieldPath],
                    addBreak: {
                      ...addBreakPath,
                      addBreak: parseInt(e.target.value, 10),
                      isDirty: true,
                    },
                  },
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
            className={addBreakPath.isDirty && "text-danger"}
          >
            <option value={1}>At End</option>
            <option value={20}>Every 20 mins</option>
            <option value={30}>Every 30 mins</option>
            <option value={60}>Every 1 hour</option>
          </Form.Select>
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={addBreakPath.isDirty}
            id="breakInputisDirty"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                preRoll: {
                  ...programDetails.preRoll,
                  [fieldPath]: {
                    ...programDetails.preRoll[fieldPath],
                    addBreak: {
                      ...addBreakPath,
                      isDirty: e.target.checked,
                    },
                  },
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
          />
        </Col>
        <Col xs={1}>Media:</Col>
        <Col xs={2}>
          <Form.Control
            id={"mediaRuntimeInput"}
            className={mediaRuntimePath.isDirty && "text-danger"}
            type="text"
            placeholder="Enter run time"
            value={mediaRuntimePath.mediaRuntime || 0}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                preRoll: {
                  ...programDetails.preRoll,
                  [fieldPath]: {
                    ...programDetails.preRoll[fieldPath],
                    mediaRuntime: {
                      ...mediaRuntimePath,
                      mediaRuntime: parseInt(e.target.value, 10),
                      isDirty: true,
                    },
                  },
                },
              });
              setFormEdited(true);
            }}
            maxLength={3}
            disabled={isLocked}
          />
        </Col>
        <Col xs={1}>
          <Form.Check // prettier-ignore
            type={"checkbox"}
            isValid
            id={"mediaRuntimeisDirty"}
            checked={mediaRuntimePath.isDirty ? true : false}
            defaultValue={mediaRuntimePath.mediaRuntime}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                preRoll: {
                  ...programDetails.preRoll,
                  [fieldPath]: {
                    ...programDetails.preRoll[fieldPath],
                    mediaRuntime: {
                      ...mediaRuntimePath,
                      isDirty: e.target.checked,
                    },
                  },
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={9}></Col>
        <Col
          xs={2}
          className="text-end"
        >
          <small>0 = default</small>
        </Col>
      </Row>
    </>
  );
};
export default PlaylistsAddBreak;
